import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  Flex,
  PrimaryButton,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';

export const useShowMemberRequestsCompleteBottomSheet =
  createUseBottomSheetModal<void, { marketThumbnail: string }>(
    ({ confirm, param }) => {
      return (
        <BottomSheetContainer hideBorder={true}>
          <Flex
            padding={{ top: 26, bottom: 14 }}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Typography type={'h5'}>콕! 찔러 쿠폰 요청 완료</Typography>
          </Flex>
          <Flex padding={{ vertical: 16 }} gap={16} alignItems={'center'}>
            <Flex overflow={'hidden'} width={52} height={52} borderRadius={26}>
              <RemoteImage uri={param.marketThumbnail} width={52} height={52} />
            </Flex>

            <Typography
              type={'body2-relaxed'}
              color={'content_secondary'}
              textAlign={'center'}
            >
              마켓이 요청을 확인하면, 쿠폰을 발행할 수 있어요.{'\n'}
              받을 수 있는 마켓 쿠폰이 생기면 푸시로 알려드릴게요.{'\n'}
              (마켓 찜 해제 시, 푸시를 받을 수 없어요)
            </Typography>
          </Flex>
          <Flex padding={{ horizontal: 16, vertical: 16 }}>
            <PrimaryButton
              color="gray"
              size="xlarge"
              variant={'fill'}
              onPress={confirm}
            >
              닫기
            </PrimaryButton>
          </Flex>
        </BottomSheetContainer>
      );
    },
  );
